export const filterAllowedMetricsOptions = (options, permissions) => {
  if (!permissions) return options;

  const restrictedMetrics = [];

  if (!permissions.allowSessionsData) {
    restrictedMetrics.push('sessions', 'total_time_spent');
  }

  if (!restrictedMetrics.length) return options;

  return options.filter((option) => !restrictedMetrics.includes(option.value));
};

export const decorateSettings = (settings) => ({
  isPending: settings.pending,
  isError: !settings.pending && settings.error,
  isLoaded: !settings.pending && !settings.error,
});
